export default __webpack_public_path__ + "static/media/Renoc.f76d1447.png";